/**
 * @generated SignedSource<<7692b3cb6e7cfecd00a99f7e21abaf68>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DesignSeriesCollection_iconicDesignSeriesPage$data = {
  readonly designs: ReadonlyArray<{
    readonly displayName: string | null;
    readonly linkData: {
      readonly isLinkable: boolean | null;
    };
    readonly " $fragmentSpreads": FragmentRefs<"DesignSeriesCollectionItem_design">;
  } | null> | null;
  readonly " $fragmentType": "DesignSeriesCollection_iconicDesignSeriesPage";
};
export type DesignSeriesCollection_iconicDesignSeriesPage$key = {
  readonly " $data"?: DesignSeriesCollection_iconicDesignSeriesPage$data;
  readonly " $fragmentSpreads": FragmentRefs<"DesignSeriesCollection_iconicDesignSeriesPage">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DesignSeriesCollection_iconicDesignSeriesPage",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "IconicDesignSeriesItem",
      "kind": "LinkedField",
      "name": "designs",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "displayName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "LinkData",
          "kind": "LinkedField",
          "name": "linkData",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isLinkable",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "DesignSeriesCollectionItem_design"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "IconicDesignSeriesPage",
  "abstractKey": null
};

(node as any).hash = "6b99e2af6fd09172eca05ff73639441a";

export default node;
